import { Component, OnInit, Input } from '@angular/core';
import { ChartColor } from 'app/assessment-charts/models/chart-color';
import { ScaleResultColorService } from 'app/assessment-charts/services/scale-result-color.service';
import { ScaleRange } from 'app/shared/models/scale-range';
import { ScaleResult } from 'app/shared/models/scale-result';

class ScaleRangeChartColor {
    constructor(public range:ScaleRange, public color:ChartColor) {}
}
@Component({
  selector: 'scale-chart-legend',
  templateUrl: './scale-chart-legend.component.html',
  styleUrls: ['./scale-chart-legend.component.css']
})
export class ScaleChartLegendComponent implements OnInit {

  @Input() rangeSize:number;
  @Input() scaleResult:ScaleResult;
  @Input() severityLabels:string[];

  private _chartColors:ChartColor[];
  
  constructor(private scaleResultColorService:ScaleResultColorService) { }

  ngOnInit() {

    if (this.scaleResult) {
      
    }
    let colors = this.scaleResultColorService.getBackgroundColors(this.rangeSize);
    if (this.severityLabels && this.severityLabels.length == colors.length) {
      colors = colors.map((r, index) => {
        return new ChartColor(this.severityLabels[index], r.color);
      });
    }
    this._chartColors = colors;
  }


	public get chartColors(): ChartColor[] {
		return this._chartColors;
	}

	public set chartColors(value: ChartColor[]) {
		this._chartColors = value;
	}
  

}



// WEBPACK FOOTER //
// ./src/app/assessment-charts/scale-chart-legend/scale-chart-legend.component.ts